module.exports = __webpack_public_path__ + "static/media/poster2.8c9009ec.jpg";